<app-loader-spinner></app-loader-spinner>

@switch (appState.mode$ | async) {
  @case (AppMode.HELP) {
    <router-outlet></router-outlet>
  }
  @case (AppMode.FORM) {
    <router-outlet></router-outlet>
  }
  @default {
    <app-top-nav [sidenav]="sidenav"></app-top-nav>
    <app-side-nav #sidenav>
      <router-outlet
        [class.wide]="(appState.mode$ | async) === AppMode.WIDE"
        [class.extra-wide]="(appState.mode$ | async) === AppMode.EXTRA_WIDE"
      ></router-outlet>
    </app-side-nav>
    <app-admin-nav></app-admin-nav>
    <app-global-document-drop></app-global-document-drop>
    @if (authService.user?.betaProgram) {
      <app-help-chat-widget></app-help-chat-widget>
    }
  }
}
<version-reload></version-reload>
